import Vue from 'vue'
import Vuex from 'vuex'
import CreatePersistedState from 'vuex-persistedstate'
import * as mutationTypes from './mutation-types'
import transaction from './modules/transaction'
import contract from './modules/contract'
import market from './modules/market'
import personal from './modules/personal'
import { tradingPairFormatReverse } from '@/utils'
import { userSignOut } from '@/api/sign'
import router from '@/router'

Vue.use(Vuex)

const ROOT_PERSIST = ['username', 'memberNumber', 'userInfo', 'token']
const MARKET_PERSIST = ['market.collectCoinListLocal'] // 行情模块
const TRANSACTION_PERSIST = [
  'transaction.tradingPair',
  'transaction.tradingPairId',
  'transaction.dollarExhibition',
  'transaction.currentSkin',
  'transaction.indicator',
  'transaction.shimHandicap',
  'transaction.buySellTop',
  'transaction.controlCoin',
  'transaction.controlPrice',
  'transaction.controlUpDown',
  'transaction.interval',
] // 交易中心模块
const CONTRACT_PERSIST = [
  'contract.indicator',
  'contract.shimHandicap',
  'contract.controlCoin',
  'contract.controlPrice',
  'contract.controlUpDown',
  'contract.interval',
] // 合约模块
const PERSONAL_PERSIST = [
  'personal.isHideAssetsData',
  'personal.isHideZeroBalance',
] // 个人中心模块

export default new Vuex.Store({
  modules: {
    contract, // 合约
    transaction: transaction, // 交易中心模块
    market: market, // 行情模块
    personal: personal, // 个人中心模块
  },
  state: {
    token: '',
    username: '', // 用户账号
    memberNumber: '', // 会员编号
    userInfo: {}, // 用户信息
  },
  getters: {
    tradingPairId(state) {
      return state.transaction.tradingPairData.marketId
    },
    parameterizedTradingPair(state) {
      return state.transaction.tradingPairData.market
    },
    tradingPair(_, getters) {
      return tradingPairFormatReverse(getters.parameterizedTradingPair)
    },
    interval(state) {
      return state.transaction.interval
    },
    isSignIn(state) {
      return !!state.token
    },
    baseCurrency(_, getters) {
      // 基础币
      return getters.tradingPair.split('/')[0]
    },
    quoteCurrency(_, getters) {
      // 报价币
      return getters.tradingPair.split('/')[1]
    },
    lowerCaseBaseCurrency(_, getters) {
      // 基础币（小写）
      return getters.baseCurrency.toLowerCase()
    },
    lowerCaseQuoteCurrency(_, getters) {
      // 报价币（小写）
      return getters.quoteCurrency.toLowerCase()
    },
  },
  mutations: {
    [mutationTypes.SET_TOKEN](state, token) {
      state.token = token
    },
    [mutationTypes.SET_USER_NAME](state, username) {
      state.username = username
    },
    [mutationTypes.SET_MEMBER_NUMBER](state, memberNumber) {
      state.memberNumber = memberNumber
    },
    [mutationTypes.SET_USER_INFO](state, userInfo) {
      state.userInfo = userInfo
    },
  },
  actions: {
    async signOut(state, isNeedToCallApi = true) {
      if (isNeedToCallApi) {
        await userSignOut()
      }
      state.commit(mutationTypes.SET_TOKEN, '')
      state.commit(mutationTypes.SET_USER_INFO, {})
      state.commit(mutationTypes.SET_USER_NAME, '')
      state.commit(mutationTypes.SET_MEMBER_NUMBER, '')
      router.push('/signin')
    },
  },
  plugins: [
    CreatePersistedState({
      storage: window.localStorage,
      paths: [
        ...ROOT_PERSIST,
        ...MARKET_PERSIST,
        ...TRANSACTION_PERSIST,
        ...PERSONAL_PERSIST,
        ...CONTRACT_PERSIST,
      ],
      // getState: (key, storage) => {
      //   const value = storage.getItem(key)
      //   console.log(value)
      //   debugger
      //   return JSON.parse(value)
      // }
    }),
  ],
})
